import api from "../utils/axios";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

const EVENT_TYPES_KEY = ["eventTypes"];

// GET all event types
export const useEventTypesQuery = (category) => {
  return useQuery({
    queryKey: category ? [...EVENT_TYPES_KEY, category] : EVENT_TYPES_KEY,
    queryFn: async () => {
      const params = category ? `?category=${category}` : "";
      const res = await api.get(`/admin/eventType${params}`);
      return res.data?.data || [];
    },
  });
};

// GET single event type by ID
export const useEventTypeByIdQuery = (id, options = {}) => {
  return useQuery({
    queryKey: [...EVENT_TYPES_KEY, id],
    queryFn: async () => {
      const res = await api.get(`/admin/eventType/${id}`);
      return res.data?.data || null;
    },
    enabled: !!id,
    ...options,
  });
};

// CREATE event type
export const useAddEventTypeMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data) => {
      const res = await api.post("/admin/eventType", data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EVENT_TYPES_KEY });
    },
    ...options,
  });
};

// UPDATE event type
export const useUpdateEventTypeMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...data }) => {
      const res = await api.put(`/admin/eventType/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EVENT_TYPES_KEY });
    },
    ...options,
  });
};

// DELETE event type (soft delete)
export const useDeleteEventTypeMutation = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/admin/eventType/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EVENT_TYPES_KEY });
    },
    ...options,
  });
};